var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLive)?_c('WLoader',{attrs:{"absolute":_vm.$vuetify.breakpoint.smAndUp,"full":true}}):(_vm.slider)?_c('WSlider',{attrs:{"absolute":_vm.$vuetify.breakpoint.smAndUp}}):_c('WProgress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }